"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var LftInputBase_1 = __importDefault(require("../LftInputBase"));
var LftIconBase_1 = __importDefault(require("../LftIconBase"));
var star_1 = __importDefault(require("@lift/assets/dist/assets/globals/icons/star"));
var star_fill_1 = __importDefault(require("@lift/assets/dist/assets/globals/icons/star_fill"));
var S = __importStar(require("./LftRanking.styles"));
var LftRanking = function (_a) {
    var bgColor = _a.bgColor, dataElement = _a.dataElement, dataTestId = _a.dataTestId, dataInfo = _a.dataInfo, disabled = _a.disabled, name = _a.name, id = _a.id, _b = _a.value, value = _b === void 0 ? 0 : _b, readOnly = _a.readOnly, lftClick = _a.lftClick;
    var items = Array.from(Array(5).keys());
    var _c = (0, react_1.useState)(value), rating = _c[0], setRating = _c[1];
    var _d = (0, react_1.useState)(value), hover = _d[0], setHover = _d[1];
    var _e = (0, react_1.useState)(false), click = _e[0], setClick = _e[1];
    var containerRef = (0, react_1.useRef)(null);
    var itemsRef = (0, react_1.useRef)([]);
    itemsRef.current = [];
    var _handleClick = function (e) {
        var status = e + 1;
        if (status === rating) {
            setRating(0);
            setHover(null);
            !!lftClick && lftClick(0);
        }
        else {
            setRating(status);
            !!lftClick && lftClick(status);
        }
    };
    var _handleKeyDown = function (event) {
        var focusedElementIndex = itemsRef.current.findIndex(function (element) { return element === document.activeElement; });
        if (event.key === 'ArrowRight') {
            event.preventDefault();
            var nextIndex = (focusedElementIndex + 1) % itemsRef.current.length;
            var nextElement = itemsRef.current[nextIndex];
            if (nextElement) {
                nextElement.focus();
                setHover(nextIndex + 1);
                _handleClick(nextIndex);
            }
        }
        else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            var prevIndex = (focusedElementIndex - 1 + itemsRef.current.length) % itemsRef.current.length;
            var prevElement = itemsRef.current[prevIndex];
            if (prevElement) {
                prevElement.focus();
                setHover(prevIndex + 1);
                _handleClick(prevIndex);
            }
        }
    };
    var _handleFocus = function (e) {
        if (hover === null && rating <= 0) {
            setHover(e + 1);
            _handleClick(e);
        }
    };
    return ((0, jsx_runtime_1.jsx)(S.Wrapper, __assign({ bgColor: bgColor, disabled: disabled, "data-lift": "lft-input", ref: containerRef, onKeyDown: _handleKeyDown, readOnly: readOnly }, { children: items.map(function (index, key) { return ((0, jsx_runtime_1.jsxs)(react_1.default.Fragment, { children: [(0, jsx_runtime_1.jsx)("label", __assign({ className: "star " + (index + 1 === rating && click ? 'clicked' : ''), htmlFor: id + "_" + key, onKeyDown: function (e) { return e.key === 'Tab' && e.preventDefault; }, onMouseMove: function () { return setHover(index + 1); }, onMouseLeave: function () { setHover(null); setClick(false); }, onFocus: function () { return _handleFocus(index); }, tabIndex: (!disabled && !readOnly) && index === rating - 1 || (!rating && index === 0) ? 0 : -1, ref: function (e) {
                        itemsRef.current[index] = e;
                    } }, { children: (0, jsx_runtime_1.jsx)(LftIconBase_1.default, { "aria-hidden": true, icon: index < (hover || rating) ? star_fill_1.default : star_1.default, bgColor: bgColor, lftClick: function () { _handleClick(index); setClick(true); } }, void 0) }), void 0), (0, jsx_runtime_1.jsx)(LftInputBase_1.default, { id: id + "_" + key, disabled: (!disabled && !readOnly), dataLift: 'radioranking', dataElement: dataElement, dataTestId: dataTestId, dataInfo: dataInfo, name: name, type: 'radio', value: index + 1 }, void 0)] }, key)); }) }), void 0));
};
exports.default = LftRanking;
